// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NA2_TheComp__YxFry"};